import { Countries, Currencies, DistanceUnit, IntlSettings, Locales } from '@grandvisionhq/state'

export const INTL_DEFAULTS: IntlSettings = {
  country: Countries.DK,
  locale: Locales['da-DK'],
  currency: Currencies.DKK,
  distanceUnit: DistanceUnit.km,
  dateFormat: {
    short: 'dd/MM/yyyy', // 06/03/2019
    midsize: 'dd MMMM yyyy', // 6 marts 2019
    narrow: 'd MMMM', // 6 marts
    long: "eeee 'd.' d. MMM yyyy", // torsdag d. 6. marts 2019
  },
}

type PossibleLocales = keyof Pick<typeof Locales, 'da-DK'>

export const intlConfigMap: {
  [L in PossibleLocales]: IntlSettings
} = {
  'da-DK': INTL_DEFAULTS,
}
